import { computed } from 'vue';
import { featureFlagService } from '@/models/feature-flag';
function newInvoiceFilterEnabled() {
    return featureFlagService.can('new-invoice-filter-modal');
}
export function useNewInvoiceFilter() {
    return computed(newInvoiceFilterEnabled);
}
// build a route link to the invoice index for a set of filter clauses. with the new
// filter modal on, filters ride history state (seedFiltersFromLegacyQuery reads them)
// instead of the URL query — so the list stops depending on ?query for filtering.
// legacyQuery is the fallback used while the flag is off.
export function invoiceIndexLink(clauses, legacyQuery) {
    if (newInvoiceFilterEnabled()) {
        return { name: 'invoice.index', state: { filters: clauses } };
    }
    return { name: 'invoice.index', query: legacyQuery };
}
// reactive variant for a single static link (dashboard-style). for per-row / dynamic
//  links, call invoiceIndexLink() directly in the template instead.
export function useInvoiceIndexLink(clauses, legacyQuery) {
    return computed(() => invoiceIndexLink(clauses, legacyQuery));
}
